import {
	useState,
} from 'react';
import classNames from 'classnames';
import Typography, {
	TypographyType,
} from 'components/typography/karim/Typography';
import {
	SvgPickup,
	SvgDelivery,
} from 'components/svg/Svg';
import {
	Colors,
} from 'utils/color/ColorPalette';
import {
	AssignmentFilterType,
} from 'utils/transport';
import './transportfilter.scss'

interface TripFilterProps {
	onSelection: (type: AssignmentFilterType) => void,
}

const TransportFilter = ({
	onSelection,
}: TripFilterProps) => {

	const [selected, setSelected] = useState(AssignmentFilterType.ALL);

	const changeFilter = (type: AssignmentFilterType) => {
		setSelected(type);
		onSelection(type);
	}

	return (
		<div className="transport-filter">
			<div className="transport-filter-container">
				<div
					tabIndex={0}
					role="button"
					onKeyPress={() =>{}}
					onClick={() => changeFilter(AssignmentFilterType.PICKUP)}
					className={classNames(
						'transport-filter-content', {
							'transport-filter-selected': selected === AssignmentFilterType.PICKUP,
						}
					)}
				>
					<SvgPickup className="transport-filter-icon-left-side" alt="Filter henting" />
					<Typography
						type={TypographyType.buttonSmall}
						style={{
							color: selected !== AssignmentFilterType.PICKUP ? Colors.neutrals.tints.gy400.hex : Colors.blue.shades.b900.hex,
						}}
					>
						Henting
					</Typography>
				</div>
				<div className="transport-filter-seperator" />
				<div
					tabIndex={0}
					role="button"
					onKeyPress={() =>{}}
					onClick={() => changeFilter(AssignmentFilterType.DELIVERY)}
					className={classNames(
						'transport-filter-content', {
							'transport-filter-selected': selected === AssignmentFilterType.DELIVERY,
						}
					)}
				>
					<SvgDelivery className="transport-filter-icon-left-side" alt="Filter levering" />
					<Typography
						type={TypographyType.buttonSmall}
						style={{
							color: selected !== AssignmentFilterType.DELIVERY ? Colors.neutrals.tints.gy400.hex : Colors.blue.shades.b900.hex,
						}}
					>
						Levering
					</Typography>
				</div>
				<div className="transport-filter-seperator" />
				<div
					tabIndex={0}
					role="button"
					onKeyPress={() =>{}}
					onClick={() => changeFilter(AssignmentFilterType.ALL)}
					className={classNames(
						'transport-filter-content', {
							'transport-filter-selected': selected === AssignmentFilterType.ALL,
						}
					)}
				>
					<Typography
						type={TypographyType.buttonSmall}
						style={{
							color: selected !== AssignmentFilterType.ALL ? Colors.neutrals.tints.gy400.hex : Colors.blue.shades.b900.hex,
						}}>
						Alle
					</Typography>
				</div>
			</div>
		</div>
	);
}

export default TransportFilter;